import { FC, useEffect, useState } from "react";
import ErrorBoundary from "../ErrorBoundary";

export const ChatLoader: FC<{
  isImage?: boolean;
  isImageGeneration?: boolean;
}> = ({ isImage, isImageGeneration }) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const timers: NodeJS.Timeout[] = [];

    // Step 1: Only dot for first 2 seconds
    // Step 2: "Thinking..." starts at 2 seconds
    timers.push(setTimeout(() => setCurrentStep(1), 2000));

    // Step 3: "Digging into details..." starts at 4 seconds
    timers.push(setTimeout(() => setCurrentStep(2), 4000));

    // Step 4: "Gathering the best response..." starts at 6 seconds
    timers.push(setTimeout(() => setCurrentStep(3), 6000));

    // Cleanup timers on unmount
    return () => timers.forEach((timer) => clearTimeout(timer));
  }, []);

  return (
    <ErrorBoundary>
      <div className="w-full h-full flex animate-pulse items-center gap-3 dark:text-white">
        {!currentStep && (
          <div className="w-4 h-4 rounded-full bg-appText dark:bg-white"></div>
        )}
        {currentStep === 1 && (
          <div className="border border-borderColor rounded-3xl px-4 py-2 animate-fadeIn">
            Thinking...
          </div>
        )}
        {currentStep === 2 && (
          <div className="border border-borderColor rounded-3xl px-4 py-2 animate-fadeIn">
            Digging into the details...
          </div>
        )}
        {currentStep === 3 && (
          <div className="border border-borderColor rounded-3xl px-4 py-2 animate-fadeIn">
            Gathering the best response...
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};